import {
  Box,
  CircularProgress,
} from "@chakra-ui/react";
export default function MyLoading() {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress isIndeterminate color="teal" />
        </Box>
    )
}